// extracted by css-extract-rspack-plugin
export default {"stack":"AvatarStack-module__stack","avatar":"AvatarStack-module__avatar","avatarHidden":"AvatarStack-module__avatarHidden","img":"AvatarStack-module__img"};